import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postHomeFormFiveSlice = createSlice({
  name: "postHomeFormFive",
  initialState,
  reducers: {
    postHomeFormFiveStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postHomeFormFiveSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postHomeTwoDataSuccess(state, action) {
      state.postData = action.payload;
    },
    postHomeFormFiveFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postHomeFormFiveStart,
  postHomeFormFiveSuccess,
  postHomeFormFiveFailure,
  postHomeTwoDataSuccess,
  clearError,
  clearMessage,
} = postHomeFormFiveSlice.actions;

export default postHomeFormFiveSlice.reducer;
